import styled from '@emotion/styled';

export const ClipboardCopyButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
`;